<template>
  <section class="caixa-especies">
    <h3 class="caixa-especies-titulo">{{ titulo }}</h3>
    <div
      v-for="pagamento in especiesVisiveis"
      :key="pagamento.key"
      class="caixa-especies-linha"
    >
      <span>{{ pagamento.descricao }} R$</span>
      <strong>{{ formatarValor(pagamento.total) }}</strong>
    </div>
    <p v-if="!especiesVisiveis.length" class="caixa-especies-vazio">
      {{ mensagemVazia }}
    </p>
  </section>
</template>

<script>
export default {
  name: "CaixaEspecies",
  props: {
    titulo: { type: String, required: true },
    mensagemVazia: { type: String, required: true },
    pagamentos: { type: Array, default: () => [] },
    formatarValor: { type: Function, required: true },
  },
  computed: {
    especiesVisiveis() {
      return (this.pagamentos || []).filter(
        (pagamento) => pagamento && Number(pagamento.total) > 0
      );
    },
  },
};
</script>

<style scoped>
.caixa-especies-titulo {
  margin: 8px 0 0;
  padding: 6px 12px;
  background: #e9edf1;
  border-top: 1px solid #dfe4ea;
  border-bottom: 1px solid #dfe4ea;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
}
.caixa-especies-linha {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 5px 12px;
  border-bottom: 1px solid #e9edf1;
  font-size: 13px;
}
.caixa-especies-linha strong {
  white-space: nowrap;
  text-align: right;
}
.caixa-especies-vazio {
  margin: 0;
  padding: 7px 12px;
  color: #6c757d;
  font-size: 12px;
}
</style>
